import React from "react";

/**
 * Central icon library. All paths are 24x24 viewBox.
 * Change path or add icons here to apply across the app.
 */
const ICON_PATHS = {
  calendar:
    "M19 4h-1V2h-2v2H8V2H6v2H5c-1.11 0-1.99.9-1.99 2L3 20c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 16H5V9h14v11zM9 11H7v2h2v-2zm4 0h-2v2h2v-2zm-8 4H7v2h2v-2zm4 0h-2v2h2v-2zm4 0h-2v2h2v-2z",
  location:
    "M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zm0 9.5c-1.38 0-2.5-1.12-2.5-2.5s1.12-2.5 2.5-2.5 2.5 1.12 2.5 2.5-1.12 2.5-2.5 2.5z",
  clock:
    "M12 2a10 10 0 1 0 10 10A10.01 10.01 0 0 0 12 2zm0 18a8 8 0 1 1 8-8a8.01 8.01 0 0 1-8 8zm.5-13H11v6l5.25 3.15l.75-1.23l-4.5-2.67z",
  edit:
    "M3 17.25V21h3.75L17.81 9.94l-3.75-3.75L3 17.25zM20.71 7.04c.39-.39.39-1.02 0-1.41l-2.34-2.34c-.39-.39-1.02-.39-1.41 0l-1.83 1.83 3.75 3.75 1.83-1.83z",
  duplicate:
    "M16 1H4c-1.1 0-2 .9-2 2v14h2V3h12V1zm3 4H8c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h11c1.1 0 2-.9 2-2V7c0-1.1-.9-2-2-2zm0 16H8V7h11v14z",
  reopen:
    "M12 5V1L7 6l5 5V7c3.31 0 6 2.69 6 6s-2.69 6-6 6-6-2.69-6-6H4c0 4.42 3.58 8 8 8s8-3.58 8-8-3.58-8-8-8z",
  // Move back / return arrow (used for "Move to backlog")
  backlog:
    "M19 7v4H5.83l3.58-3.59L8 6l-6 6 6 6 1.41-1.41L5.83 13H21V7h-2z",
  delete:
    "M6 19c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2V7H6v12zM19 4h-3.5l-1-1h-5l-1 1H5v2h14V4z",
  close:
    "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 15l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z",
  invite:
    "M20 4H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6l-8-5-8 5V6c0-1.1-.9-2-2-2zm0 4l-8 5-8-5V6h16v2z",
  // Swap / transfer arrows for email change actions
  swapEmail:
    "M6.99 11L3 15l3.99 4v-3H14v-2H6.99v-3zM21 9l-3.99-4v3H10v2h7.01v3L21 9z",
  // Key icon for verification / one-time code actions
  verificationCode:
    "M12.65 10C11.83 7.67 9.61 6 7 6c-3.31 0-6 2.69-6 6s2.69 6 6 6c2.61 0 4.83-1.67 5.65-4H17v4h4v-4h2v-4H12.65zM7 14c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2z",
  questions:
    "M3 13h2v-2H3v2zm0 4h2v-2H3v2zm0-8h2V7H3v2zm4 4h14v-2H7v2zm0 4h14v-2H7v2zM7 7v2h14V7H7z",
  view:
    "M12 4.5C7 4.5 2.73 7.61 1 12c1.73 4.39 6 7.5 11 7.5s9.27-3.11 11-7.5c-1.73-4.39-6-7.5-11-7.5zM12 17c-2.76 0-5-2.24-5-5s2.24-5 5-5 5 2.24 5 5-2.24 5-5 5zm0-8c-1.66 0-3 1.34-3 3s1.34 3 3 3 3-1.34 3-3-1.34-3-3-3z",
  // Slashed eye — hide / password currently visible
  viewOff:
    "M12 7c2.76 0 5 2.24 5 5 0 .65-.13 1.26-.36 1.83l2.92 2.92c1.51-1.26 2.7-2.89 3.43-4.75-1.73-4.39-6-7.5-11-7.5-1.4 0-2.74.25-3.98.7l2.16 2.16C10.74 7.13 11.35 7 12 7zM2 4.27l2.28 2.28.46.46C3.08 8.3 1.78 10.02 1 12c1.73 4.39 6 7.5 11 7.5 1.55 0 3.03-.3 4.38-.84l.42.42L19.73 22 21 20.73 3.27 3 2 4.27zM7.53 9.8l1.55 1.55c-.05.21-.08.43-.08.65 0 1.66 1.34 3 3 3 .22 0 .44-.03.65-.08l1.55 1.55c-.67.33-1.41.53-2.2.53-2.76 0-5-2.24-5-5 0-.79.2-1.53.53-2.2zm4.31-.78l3.15 3.15.02-.16c0-1.66-1.34-3-3-3l-.17.01z",
  // List/table view (3 rows)
  list:
    "M4 6h2v2H4V6zm4 0h12v2H8V6zm-4 5h2v2H4v-2zm4 0h12v2H8v-2zm-4 5h2v2H4v-2zm4 0h12v2H8v-2z",
  // Grid/card view (2x2)
  grid:
    "M4 4h7v7H4V4zm9 0h7v7h-7V4zM4 13h7v7H4v-7zm9 0h7v7h-7v-7z",
  leads:
    "M16 11c1.66 0 2.99-1.34 2.99-3S17.66 5 16 5c-1.66 0-3 1.34-3 3s1.34 3 3 3zm-8 0c1.66 0 2.99-1.34 2.99-3S9.66 5 8 5C6.34 5 5 6.34 5 8s1.34 3 3 3zm0 2c-2.33 0-7 1.17-7 3.5V19h14v-2.5c0-2.33-4.67-3.5-7-3.5zm8 0c-.29 0-.62.02-.97.05 1.16.84 1.97 1.97 1.97 3.45V19h6v-2.5c0-2.33-4.67-3.5-7-3.5z",
  impersonate:
    "M12 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm0 2c-2.67 0-8 1.34-8 4v2h16v-2c0-2.66-5.33-4-8-4z",
  approve:
    "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 15l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z",
  payment:
    "M20 4H4c-1.11 0-1.99.89-1.99 2L2 18c0 1.11.89 2 2 2h16c1.11 0 2-.89 2-2V6c0-1.11-.89-2-2-2zm0 14H4v-6h16v6zm0-10H4V6h16v2z",
  save:
    "M17 3H5c-1.11 0-2 .9-2 2v14c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2V7l-4-4zm-5 16c-1.66 0-3-1.34-3-3s1.34-3 3-3 3 1.34 3 3-1.34 3-3 3zm3-10H5V5h10v4z",
  cancel:
    "M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z",
  participants:
    "M7 12c1.66 0 3-1.34 3-3S8.66 6 7 6 4 7.34 4 9s1.34 3 3 3zm10 0c1.66 0 3-1.34 3-3s-1.34-3-3-3-3 1.34-3 3 1.34 3 3 3zM7 14c-2.67 0-8 1.34-8 4v2h6v-2c0-1.1.9-2 2-2h2.09C8.57 14.86 7.76 14 7 14zm10 0c-.76 0-1.57.86-2.09 2H17c1.1 0 2 .9 2 2v2h6v-2c0-2.66-5.33-4-8-4z",
  // Navigation chevrons for calendars (thicker stroke)
  chevronLeft:
    "M15.5 6l-1.41-1.41L8.09 10.5l5.99 5.91L15.5 15 11 10.5 15.5 6z",
  chevronRight:
    "M8.5 6l1.41-1.41 5.99 5.91-5.99 5.91L8.5 15 13 10.5 8.5 6z",
  // Simple plus-in-circle for generic "add" actions (legacy)
  add:
    "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 11h3v-2h-3V8h-2v3H8v2h3v3h2v-3z",
  // Magic wand icon for generic smart features (legacy)
  magic:
    "M4 20l4-4 2 2-4 4H4v-2zm9.71-15.71l1.59 1.59L14 7.88l1.41 1.41 1.3-1.29 1.59 1.59L20.71 8 19.12 6.41 20.41 5l-1.41-1.41L17.71 4 16.12 2.41 14.71 3.83zM11 9l2 2L7 17l-2-2 6-6z",
  // Lightning bolt for NLP / smart add actions
  lightning:
    "M13 2L4 14h6l-1 8 9-12h-6l1-8z",
  // Split arrows (used for splitting transactions)
  split:
    "M4 4h6v2H6v2c0 1.66 1.34 3 3 3h2c2.76 0 5 2.24 5 5v1h3l-4 4-4-4h3v-1c0-1.66-1.34-3-3-3H9c-2.76 0-5-2.24-5-5V6H4V4zm12 2h-3l4-4 4 4h-3v6c0 1.66-1.34 3-3 3h-1v-2h1c.55 0 1-.45 1-1V6z",
  // Document with a small plus badge (for Add Task)
  docPlus:
    "M14 2H6c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h4.1A5.002 5.002 0 0119 13V8l-5-6zm0 2.5L17.5 8H14V4.5zM10 12H6v-2h4v2zm0-3H6V7h4v2zM19 14a3 3 0 100 6 3 3 0 000-6zm1 3h-1v1h-2v-1h-1v-2h1v-1h2v1h1v2z",
  // Filled sparkles — strong visual weight next to duplicate/delete (AI / smart add tasks)
  aiAddTasks:
    "M12 4L17.5 12 12 20 6.5 12 12 4zM17.5 3.25l1.4 1.4L17.5 6.05l-1.4-1.4L17.5 3.25zM6.75 5.5L8.1 6.85 6.75 8.2 5.4 6.85 6.75 5.5z",
  label:
    "M21.41 11.58l-9-9C12.05 2.22 11.55 2 11 2H4c-1.1 0-2 .9-2 2v7c0 .55.22 1.05.59 1.42l9 9c.36.36.86.58 1.41.58.55 0 1.05-.22 1.41-.59l7-7c.37-.36.59-.86.59-1.41 0-.55-.23-1.06-.59-1.42zM5.5 7C4.67 7 4 6.33 4 5.5S4.67 4 5.5 4 7 4.67 7 5.5 6.33 7 5.5 7z",
  // Chain / link for copyable share URLs
  link:
    "M3.9 12c0-1.71 1.39-3.1 3.1-3.1h4V7H7c-2.76 0-5 2.24-5 5s2.24 5 5 5h4v-1.9H7c-1.71 0-3.1-1.39-3.1-3.1zM8 13h8v-2H8v2zm9-6h-4v1.9h4c1.71 0 3.1 1.39 3.1 3.1s-1.39 3.1-3.1 3.1h-4V17h4c2.76 0 5-2.24 5-5s-2.24-5-5-5z",
};

/** Icon name constants for type-safe usage */
export const ICON_NAMES = {
  calendar: "calendar",
  location: "location",
  clock: "clock",
  edit: "edit",
  duplicate: "duplicate",
  reopen: "reopen",
  backlog: "backlog",
  delete: "delete",
  close: "close",
  invite: "invite",
  swapEmail: "swapEmail",
  verificationCode: "verificationCode",
  questions: "questions",
  view: "view",
  viewOff: "viewOff",
  list: "list",
  grid: "grid",
  leads: "leads",
  impersonate: "impersonate",
  approve: "approve",
  payment: "payment",
  save: "save",
  cancel: "cancel",
  participants: "participants",
  chevronLeft: "chevronLeft",
  chevronRight: "chevronRight",
  add: "add",
  magic: "magic",
  lightning: "lightning",
  docPlus: "docPlus",
  aiAddTasks: "aiAddTasks",
  split: "split",
  label: "label",
  link: "link",
};

/** Shared style for icon-only action buttons in tables (use with title for tooltip) */
export const iconBtnStyle = {
  padding: "2px",
  border: "none",
  background: "none",
  cursor: "pointer",
  color: "inherit",
  display: "inline-flex",
  alignItems: "center",
  justifyContent: "center",
  flexShrink: 0,
  minWidth: 24,
  minHeight: 24,
};

export { RowActionIcons, ROW_ACTION_ICONS_CLASS } from "../../components/RowActionIcons";

const VIEWBOX = "0 0 24 24";

/**
 * Renders an icon by name. Use this when you need a single place to change size or props.
 * @param {string} name - Key from ICON_NAMES / ICON_PATHS
 * @param {number} [size=24] - Width and height in px
 * @param {object} [props] - Extra props for the svg (className, style, etc.)
 */
export function Icon({ name, size = 24, ...props }) {
  const path = ICON_PATHS[name];
  if (!path) return null;
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox={VIEWBOX}
      fill="currentColor"
      width={size}
      height={size}
      aria-hidden="true"
      {...props}
    >
      <path d={path} />
    </svg>
  );
}

/** Named icon components for convenience; all use 24px by default, override with size prop */
export function IconCalendar(props) {
  return <Icon name={ICON_NAMES.calendar} {...props} />;
}
export function IconLocation(props) {
  return <Icon name={ICON_NAMES.location} {...props} />;
}
export function IconClock(props) {
  return <Icon name={ICON_NAMES.clock} {...props} />;
}
export function IconEdit(props) {
  return <Icon name={ICON_NAMES.edit} {...props} />;
}
export function IconDuplicate(props) {
  return <Icon name={ICON_NAMES.duplicate} {...props} />;
}
export function IconReopen(props) {
  return <Icon name={ICON_NAMES.reopen} {...props} />;
}
export function IconBacklog(props) {
  return <Icon name={ICON_NAMES.backlog} {...props} />;
}
export function IconDelete(props) {
  return <Icon name={ICON_NAMES.delete} {...props} />;
}
export function IconClose(props) {
  return <Icon name={ICON_NAMES.close} {...props} />;
}
export function IconInvite(props) {
  return <Icon name={ICON_NAMES.invite} {...props} />;
}
export function IconSwapEmail(props) {
  return <Icon name={ICON_NAMES.swapEmail} {...props} />;
}
export function IconVerificationCode(props) {
  return <Icon name={ICON_NAMES.verificationCode} {...props} />;
}
export function IconQuestions(props) {
  return <Icon name={ICON_NAMES.questions} {...props} />;
}
export function IconView(props) {
  return <Icon name={ICON_NAMES.view} {...props} />;
}
export function IconViewOff(props) {
  return <Icon name={ICON_NAMES.viewOff} {...props} />;
}
export function IconList(props) {
  return <Icon name={ICON_NAMES.list} {...props} />;
}
export function IconGrid(props) {
  return <Icon name={ICON_NAMES.grid} {...props} />;
}
export function IconLeads(props) {
  return <Icon name={ICON_NAMES.leads} {...props} />;
}
export function IconImpersonate(props) {
  return <Icon name={ICON_NAMES.impersonate} {...props} />;
}
export function IconApprove(props) {
  return <Icon name={ICON_NAMES.approve} {...props} />;
}
export function IconPayment(props) {
  return <Icon name={ICON_NAMES.payment} {...props} />;
}
export function IconSave(props) {
  return <Icon name={ICON_NAMES.save} {...props} />;
}
export function IconCancel(props) {
  return <Icon name={ICON_NAMES.cancel} {...props} />;
}
export function IconParticipants(props) {
  return <Icon name={ICON_NAMES.participants} {...props} />;
}
export function IconChevronLeft(props) {
  return <Icon name={ICON_NAMES.chevronLeft} {...props} />;
}
export function IconChevronRight(props) {
  return <Icon name={ICON_NAMES.chevronRight} {...props} />;
}
export function IconAdd(props) {
  return <Icon name={ICON_NAMES.add} {...props} />;
}
export function IconMagic(props) {
  return <Icon name={ICON_NAMES.magic} {...props} />;
}
export function IconLightning(props) {
  return <Icon name={ICON_NAMES.lightning} {...props} />;
}
export function IconDocPlus(props) {
  return <Icon name={ICON_NAMES.docPlus} {...props} />;
}
export function IconAiAddTasks(props) {
  return <Icon name={ICON_NAMES.aiAddTasks} {...props} />;
}
export function IconSplit(props) {
  return <Icon name={ICON_NAMES.split} {...props} />;
}
export function IconLabel(props) {
  return <Icon name={ICON_NAMES.label} {...props} />;
}
export function IconLink(props) {
  return <Icon name={ICON_NAMES.link} {...props} />;
}

/** Mapping for programmatic use: name -> React element (default 24px). Use Icon component for custom size. */
export function getIcon(name, size = 24) {
  return <Icon name={name} size={size} />;
}

export default Icon;
